import { Box, CircularProgress } from '@material-ui/core';

import { StoreSaturationInfo } from '../../../store-saturation-info';

export function ListOfStores({ list, onClickStore, isLoading }) {
  return (
    <Box
      component='section'
      p='2px 2px 0.5rem'
      display='flex'
      flexDirection='column'
      gridGap='0.5rem'
    >
      {!isLoading &&
        list.map(store => (
          <StoreSaturationInfo
            key={`store-${store.store_id}`}
            storeName={store.name}
            variant={store.saturated}
            storeAddress={store.address}
            onClick={() => onClickStore(store.store_id)}
          />
        ))}
      {isLoading && (
        <CircularProgress style={{ display: 'block', margin: '4rem auto' }} />
      )}
    </Box>
  );
}
